<template>
  <div id="gos-virusdb-report-table">
    <div
      class="repTbale"
      v-if="tableData != undefined"
    >
      <el-table
        ref="multipleTable"
        border
        :row-key="record => record.id"
        @selection-change="handleSelectionChange"
        :header-cell-style="{
          background: '#DEDEDE',
          color: '#555',
          fontWeight: '500',
          fontSize: '14px',
          padding: '6px 0'
        }"
        :cell-style="{ color: '#555', fontSize: '14px', padding: '6px 0' }"
        :data="data"
      >
        <el-table-column
          v-if="select"
          type="selection"
          :reserve-selection="true"
          width="40"
        >
        </el-table-column>
        <el-table-column
          v-for="item in tableData.cols"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :min-width="item.minWidth"
          :sortable="item.sort || false"
        >
          <template slot-scope="scope">
            <!-- 对某些字段自定义样式 -->
            <el-checkbox
              v-if="item.prop == 'checkbox'"
              v-model="scope.row[item.prop]"
            ></el-checkbox>
            <span v-else-if="item.prop == 'AAChange'">
              <aa-change :data="scope.row"></aa-change>
            </span>
            <span v-else-if="item.prop == 'accession'">
              <a
                class="accession"
                @click="alignmentDetail(scope.row[item.prop])"
              >{{ scope.row[item.prop] }}</a>
            </span>
            <span v-else-if="item.prop == 'query_cover'">
              {{ percent(scope.row[item.prop]) }}
            </span>
            <span v-else-if="item.prop == 'Location of match in genome'">
              <svg-pic
                :retinue="retinue"
                :bigSVG="scope.row.cstrain"
                :svgData="scope.row.accession"
                :svgId="'templeSvg-' + scope.row['indexId']"
              ></svg-pic>
            </span>
            <span v-else>{{  scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      class="pagination"
      v-if="newTotal > limit"
    >
      <paging
        :total="newTotal"
        :page.sync="cpage"
      ></paging>
    </div>
    <el-dialog title="Blast Result" :visible.sync="dialogTableVisible">
      <div class="dag-content">
        <br />
        <h3 class="dag-title" align="left">
          Sequence ID: {{this.retinueData.sequenceId}}
        </h3>
        <br />
        <div v-for="(hsp, index) in hspsArray" :key="index" :id="'hspid_' + index">
          <div style="background-color: #eeffff;">
            <hr style="background-color: #393d49 !important; height: 1px; margin: 10px 0; border: 0; clear: both;">
            <div>
                <span>Range: {{hsp.num}}</span>
                <span>&emsp; Query Range: {{hsp.query_from}} - {{hsp.query_to}}</span>
                <span>&emsp; Subject Range: {{hsp.hit_from}} - {{hsp.hit_to}}</span>
            </div>
            <div style="padding-top: 5px; position: relative;">
              <div style="display: inline;">
                <span>Score: {{hsp.bit_score}}</span>
                <span>&emsp; Expect: {{hsp.evalue}}</span>
                <span>&emsp; Identities: {{hsp.identity}}/{{hsp.align_len}}({{hsp.strQueryCover}})</span>
                <span>&emsp; Gaps: {{hsp.gaps}}/{{hsp.align_len}}({{hsp.strGaps}})</span>
                <span>&emsp; Strand: {{hsp.query_strand}}/{{hsp.hit_strand}}</span>
              </div>
              <div style="position: absolute; right: 10px; display: inline;">
                <el-link type="primary" icon="el-icon-arrow-up" :underline="false" :disabled="index === 0" :href="'#hspid_'+(index-1)">Previous</el-link>
                <el-link type="primary" icon="el-icon-arrow-down" :underline="false" style="margin-left: 15px;" :disabled="index === hspsArray.length - 1"
                  :href="'#hspid_'+(index+1)">Next</el-link>
              </div>
            </div>
            <hr style="background-color: #393d49 !important; height: 1px; margin: 10px 0; border: 0; clear: both;">
          </div>
          <div><pre v-html="hsp.sequence"></pre></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import paging from '../components/paging.vue'
import svgPic from './svgPicture.vue'
export default {
  name: 'gos-virusdb-report-table',
  props: {
    // 用于存放一些附带参数，在自定义某列的操作时可使用
    retinue: {
      type: Object
    },
    tableData: {
      type: Object,
      required: true
    },
    // 是否开启前端分页
    openPage: {
      type: Boolean
    },
    select: {
      type: Boolean
    },
    limit: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 1
    }
  },
  mounted () {
    if (this.openPage) {
      if (this.tableData.datas.length < this.limit) {
        this.newTotal = this.tableData.datas.length
        this.data = this.tableData.datas
      } else {
        this.newTotal = this.tableData.datas.length
        for (let i = 0; i < this.limit; i++) {
          this.data.push(this.tableData.datas[i])
        }
      }
    } else {
      this.newTotal = this.total
      this.data = this.tableData.datas
    }
  },
  watch: {
    cpage (newVal, oldVal) {
      this.changePage(newVal)
    }
  },
  methods: {
    percent (val) {
      let num = Number(val.replace('%', ''))
      if (num > 100) {
        return '100%'
      } else {
        return val
      }
    },
    alignmentDetail (accession) {
      for (let i in this.retinue.alignment) {
        if (this.retinue.alignment[i].description.map(desc => desc.id).indexOf(accession) >= 0) {
          this.openSeqAlignmentDetail(this.retinue.alignment[i])
          break
        }
      }
    },
    openSeqAlignmentDetail (ali) {
      this.accession = ali.description[0].accession
      this.dialogTableVisible = true
      this.retinueData.sequenceId = ali.description[0].id
      const countInLine = 117
      this.hspsArray = []
      for (let hsp of ali.hsps) {
        let strQseq = hsp.qseq
        let strMidline = hsp.midline
        let strHseq = hsp.hseq
        let strQseqArr = []
        let strMidlineArr = []
        let strHseqArr = []
        for (let i = 0; i < strQseq.length; i++) {
          let Q = strQseq.slice(i, i + 1)
          let M = strMidline.slice(i, i + 1)
          strMidlineArr.push(M)
          let H = strHseq.slice(i, i + 1)
          if (Q.toLowerCase() !== H.toLowerCase()) {
            let color = this._getColorByBase(Q)
            if (color !== '') {
              Q = "<div style='display:inline;background-color: " + color + ";'>" + Q + '</div>'
            }
            color = this._getColorByBase(H)
            if (color !== '') {
              H = "<div style='display:inline;background-color: " + color + ";'>" + H + '</div>'
            }
          }
          strQseqArr.push(Q)
          strHseqArr.push(H)
        }
        let str = ''
        for (let i = 0; i < strQseqArr.length; i += countInLine) {
          str += [strQseqArr.slice(i, i + countInLine).join(''), strMidlineArr.slice(i, i + countInLine).join(''),
            strHseqArr.slice(i, i + countInLine).join(''), ''].join('<br/>') + '<hr/>'
        }
        let ahsp = {
          ...hsp,
          sequence: str,
          strQueryCover: Number(hsp.identity / hsp.align_len * 100).toFixed(1) + '%',
          strGaps: Number((hsp.gaps / hsp.align_len) * 100).toFixed(1) + '%'
        }
        this.hspsArray.push(ahsp)
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    changePage (val) {
      if (this.openPage) {
        let page = val
        this.data = []
        for (
          let i = 0;
          i < this.limit && i + (page - 1) * 10 < this.tableData.datas.length;
          i++
        ) {
          this.data.push(this.tableData.datas[i + (page - 1) * 10])
        }
      } else {
        this.$emit('update:page', val)
      }
    },
    AAChange (val) {
    },
    _getColorByBase (base) {
      if (base === 'T') {
        return '#f00'
      } else if (base === 'A') {
        return '#00BF00'
      } else if (base === 'C') {
        return '#4747ff'
      } else if (base === 'G') {
        return '#d5bb04'
      } else {
        return '#f00'
      }
    }
  },
  data () {
    return {
      multipleSelection: [],
      newTotal: 0,
      alignmentContent: '',
      retinueData: {},
      data: [],
      accession: '',
      inputPage: 1,
      cpage: this.page,
      dialogTableVisible: false,
      value: '10',
      hspsArray: []
    }
  },
  components: {
    paging,
    svgPic
  }
}
</script>
<style>
.el-tooltip__popper {
  max-width: 30%;
}
</style>

<style scoped>
.bg-black {
  background-color: #393d49 !important;
  height: 1px;
  margin: 10px 0;
  border: 0;
  clear: both;
}
#gos-virusdb-report-table {
  width: 100%;
}
.accession {
  text-decoration: underline;
  cursor: pointer;
  color: #409eff;
}
.repTbale {
  overflow: auto;
}
.pagination {
  width: 100%;
  margin-top: 20px;
  text-align: left;
  /* background: #fff; */
}
#gos-virusdb-report-table >>> .el-table .cell {
  cursor: default;
}
#gos-virusdb-report-table >>> .el-dialog {
  width: 1050px;
  height: 600px;
}
#gos-virusdb-report-table >>> .el-dialog__body {
  padding: 0 20px;
  height: 500px;
  overflow: auto;
}
#gos-virusdb-report-table >>> .el-checkbox__inner:hover {
  border-color: #05579e;
}

#gos-virusdb-report-table
  >>> .el-checkbox__input.is-checked
  .el-checkbox__inner,
#gos-virusdb-report-table
  >>> .el-checkbox__input.is-indeterminate
  .el-checkbox__inner {
  border-color: #05579e;
  background-color: #05579e;
}
.dag-content {
  height: 500;
  line-height: 22px;
  overflow-y: auto;
}
.dag-title {
  color: #666;
  font-weight: 400;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/gos-virusdb-report-table.vue